"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[9991],{

/***/ 29991:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ Panorama; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_class_call_check.mjs
var _class_call_check = __webpack_require__(51438);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_inherits.mjs + 1 modules
var _inherits = __webpack_require__(88029);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_create_super.mjs + 1 modules
var _create_super = __webpack_require__(71418);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(34051);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./components/common/LoadingProgress/index.tsx + 1 modules
var LoadingProgress = __webpack_require__(3403);
// EXTERNAL MODULE: ./node_modules/moment/moment.js
var moment = __webpack_require__(30381);
var moment_default = /*#__PURE__*/__webpack_require__.n(moment);
;// CONCATENATED MODULE: ./components/tour/regular/panorama/Pannellum.tsx



var w = window;
var Pannellum = /*#__PURE__*/ function() {
    "use strict";
    function Pannellum(props) {
        (0,_class_call_check/* default */.Z)(this, Pannellum);
        this.loaded = false;
        this.status = 0 // 0 - init, 1 - loading, 2 - done
        ;
        this.onLoaded = props.onLoaded;
        this.showLoading = props.showLoading;
        this.autoLoad = props.autoLoad;
        this.hd = props.hd;
        this.id = "panorama-player-".concat(props.id);
        this.index = props.id - 1;
        this.firstScene = props.firstScene;
        this.hotspotsMap = {};
        this.loadCurrentScenes = props.loadCurrentScenes;
        this.updatePanoRotation = props.updatePanoRotation;
        this.openHotspot = props.openHotspot;
        this.active = false;
        this.loadSelf = props.loadSelf;
        this.transition = props.transition;
        this.init();
    }
    var _proto = Pannellum.prototype;
    _proto.init = function init() {
        var _this = this;
        if (this.status === 1 || this.status === 2) return;
        this.status = 1;
        this.viewer = w.pannellum.viewer(this.id, {
            default: {
                firstScene: this.firstScene
            },
            autoLoad: this.autoLoad,
            showControls: false,
            scenes: [],
            compass: true,
            crossOrigin: "anonymous"
        });
        this.status = 2;
        this.viewer.on("animatefinished", function(pos) {
            if (_this.active) {
                _this.updatePanoRotation(_this.getNorthOffset(), pos, _this.viewer.getScene());
            }
        });
        this.viewer.on("load", function() {
            _this.loaded = true;
            if (_this.active) {
                _this.onLoaded(_this.id);
            }
        });
        this.viewer.on("error", function(e) {
            console.error("panorama error:", e);
            _this.onLoaded(_this.id);
        });
    };
    _proto.addScene = function addScene(scene) {
        var config = this.getMultires(scene);
        if (scene.hotspots) {
            config.hotSpots = [];
            for(var i = 0; i < scene.hotspots.length; i += 1){
                var h = (0,_object_spread/* default */.Z)({
                    sceneUrl: scene.url
                }, scene.hotspots[i]);
                config.hotSpots.push(this.generateHotspot(h, scene));
            }
        }
        this.viewer.addScene(scene.name, config);
    };
    _proto.generateHotspot = function generateHotspot(hotspot, scene) {
        var ref;
        hotspot.id = "h-".concat(hotspot.id);
        hotspot.title = hotspot.name;
        hotspot.createTooltipFunc = Pannellum.addDivs(scene);
        hotspot.createTooltipArgs = {
            text: hotspot.name,
            animated: hotspot.type === "panorama",
            iconFile: hotspot.iconFile,
            iconColor: hotspot.iconColor
        };
        if ((ref = hotspot.iconFile) === null || ref === void 0 ? void 0 : ref.length) {
            hotspot.cssClass = "pano-hotspot pnlm-tooltip pnlm-custom-icon";
        } else {
            hotspot.cssClass = hotspot.icon ? "pano-hotspot pnlm-tooltip ".concat(hotspot.icon) : "pano-hotspot pnlm-tooltip fas fa-eye";
        }
        if (hotspot.type === "image") {
            hotspot.url = "".concat("https://cdn.treedis.com", "/tours/").concat(scene.tourId, "/panoramas/").concat(hotspot.sceneUrl, "/").concat(hotspot.url);
            hotspot.urlMobile = "".concat("https://cdn.treedis.com", "/tours/").concat(scene.tourId, "/mobile/panoramas/").concat(hotspot.sceneUrl, "/").concat(hotspot.urlMobile);
        }
        if (hotspot.type === "panorama") {
            var _this = this;
            if (!hotspot.useIcon) {
                hotspot.cssClass = "pano-hotspot pnlm-tooltip animated pano-arrows";
            }
            hotspot.clickHandlerFunc = function() {
                if (!_this.transition) {
                    _this.loadSelf(hotspot.scene);
                } else {
                    var _this1 = _this;
                    _this.showLoading(true);
                    var nextPannellum = _this.hotspotsMap[hotspot.id];
                    if (!nextPannellum.isLoaded()) return;
                    _this.zoomIn(hotspot.pitch, hotspot.yaw);
                    setTimeout(function() {
                        _this1.show(nextPannellum.id);
                    }, 200);
                    setTimeout(function() {
                        _this1.loadCurrentScenes(hotspot.scene, nextPannellum.index);
                    }, 550);
                }
            };
        } else if (hotspot.type === "tab") {
            hotspot.URL = hotspot.url;
        } else if (hotspot.type !== "text") {
            var _this1 = this;
            hotspot.clickHandlerFunc = function() {
                _this1.openHotspot(hotspot);
            };
        }
        return hotspot;
    };
    _proto.zoomIn = function zoomIn(pitch, yaw) {
        if (this.viewer) {
            var bounds = this.viewer.getHfovBounds();
            this.lookAt({
                pitch: pitch,
                yaw: yaw,
                bounds: bounds[0],
                time: 1000
            });
        }
    };
    // eslint-disable-next-line class-methods-use-this
    _proto.getMultires = function getMultires(scene) {
        var config = {};
        if (scene.hd) {
            config = {
                type: scene.type,
                multiRes: {
                    basePath: "".concat("https://cdn.treedis.com", "/tours/").concat(scene.tourId, "/panoramas/").concat(scene.url, "/"),
                    path: scene.path,
                    fallbackPath: scene.fallbackPath,
                    extension: scene.extension,
                    tileResolution: scene.tileResolution,
                    maxLevel: scene.maxLevel,
                    cubeResolution: scene.cubeResolution
                }
            };
        } else {
            config = {
                panorama: "".concat("https://cdn.treedis.com", "/tours/").concat(scene.tourId, "/panoramas/").concat(scene.url, "/full.jpg?v=").concat(moment_default()().format("HHmmss"))
            };
        }
        return config;
    };
    _proto.show = function show(showId) {
        var toHide = document.getElementById(this.id);
        var toShow = document.getElementById(showId);
        if (toHide && toShow) {
            if (toHide) toHide.style.opacity = "0";
            toShow.classList.add("show");
            toShow.style.opacity = "1";
            setTimeout(function() {
                toHide.classList.remove("show");
            }, 500);
        }
    };
    _proto.loadScene = function loadScene(param) {
        var scene = param.scene, pitch = param.pitch, yaw = param.yaw, hfov = param.hfov;
        if (!this.viewer) throw new Error("No viewer");
        if (pitch && yaw) {
            if (hfov) {
                this.viewer.loadScene(scene, pitch, yaw, hfov);
            } else {
                this.viewer.loadScene(scene, pitch, yaw);
            }
        } else {
            this.viewer.loadScene(scene);
        }
    };
    _proto.lookAt = function lookAt(param) {
        var pitch = param.pitch, yaw = param.yaw, bounds = param.bounds, time = param.time;
        if (!this.viewer) throw new Error("No viewer");
        if (bounds && time) {
            return this.viewer.lookAt(pitch, yaw, bounds, time);
        }
        return this.viewer.lookAt(pitch, yaw);
    };
    _proto.removeScene = function removeScene(scene) {
        if (!this.viewer) throw new Error("No viewer");
        return this.viewer.removeScene(scene);
    };
    _proto.getScene = function getScene() {
        if (!this.viewer) throw new Error("No viewer");
        return this.viewer.getScene();
    };
    _proto.getYaw = function getYaw() {
        if (!this.viewer) throw new Error("No viewer");
        return this.viewer.getYaw();
    };
    _proto.isLoaded = function isLoaded() {
        if (!this.viewer) throw new Error("No viewer");
        return this.viewer.isLoaded();
    };
    _proto.setNorthOffset = function setNorthOffset(offset) {
        if (!offset) return null;
        if (!this.viewer) throw new Error("No viewer");
        // the compass of pannellum rotates against the clock. 90deg is 10pm
        return this.viewer.setNorthOffset(offset > 0 ? 360 - offset : offset * -1);
    };
    _proto.setPose = function setPose(pose) {
        if (!this.viewer) throw new Error("No viewer");
        if (pose.pitch) {
            this.viewer.setPitch(pose.pitch, true);
        }
        if (pose.yaw) {
            this.viewer.setYaw(pose.yaw, true);
        }
        if (pose.hfov) {
            this.viewer.setHfov(pose.hfov, true);
        }
    };
    _proto.getNorthOffset = function getNorthOffset() {
        if (!this.viewer) throw new Error("No viewer");
        return this.viewer.getNorthOffset();
    };
    _proto.destroyViewer = function destroyViewer() {
        if (!this.viewer) throw new Error("No viewer");
        return this.viewer.destroy();
    };
    return Pannellum;
}();
Pannellum.addDivs = function(scene) {
    return function(hotSpotDiv, args) {
        if (args.text) {
            var span = document.createElement("span");
            span.innerHTML = args.text;
            hotSpotDiv.appendChild(span);
            span.style.width = "".concat(span.scrollWidth + 10, "px");
            span.style.marginLeft = "".concat(-(span.scrollWidth - hotSpotDiv.offsetWidth) / 2, "px");
            span.style.marginTop = "".concat(-span.scrollHeight - 12, "px");
        }
        if (args.animated) {
            var div = document.createElement("div");
            var div2 = document.createElement("div");
            hotSpotDiv.appendChild(div);
            hotSpotDiv.appendChild(div2);
        }
        if (args.iconFile) {
            var img = document.createElement("img");
            var baseUrl = "".concat("https://cdn.treedis.com", "/tours/").concat(scene.tourId, "/panoramas");
            img.src = "".concat(baseUrl, "/").concat(scene.url, "/").concat(args.iconFile);
            hotSpotDiv.appendChild(img);
        }
        if (args.iconColor) {
            hotSpotDiv.style.color = args.iconColor;
        }
    };
};


// EXTERNAL MODULE: ./_helpers/renderDebug.ts
var renderDebug = __webpack_require__(66725);
;// CONCATENATED MODULE: ./components/tour/regular/panorama/Panorama.tsx











var Panorama = /*#__PURE__*/ function(PureComponent) {
    "use strict";
    (0,_inherits/* default */.Z)(Panorama, PureComponent);
    var _super = (0,_create_super/* default */.Z)(Panorama);
    function Panorama(props) {
        (0,_class_call_check/* default */.Z)(this, Panorama);
        var _this;
        _this = _super.call(this, props);
        _this.pannellums = [];
        _this.scenes = {};
        _this.onPanoLoaded = function() {
            _this.setState({
                loaded: true
            });
        };
        _this.showLoading = function(checkGuest) {
            if (checkGuest) {
                if (_this.props.isChatGuest) {
                    _this.setState({
                        loaded: false
                    });
                }
            } else {
                _this.setState({
                    loaded: false
                });
            }
        };
        _this.loadSelf = function(scene) {
            _this.pannellums[0].loadScene({
                scene: scene,
                pitch: _this.scenes[scene].startPitch,
                yaw: _this.scenes[scene].startYaw,
                hfov: _this.scenes[scene].hfov
            });
        };
        _this.getPanoHotspots = function(scene) {
            if (!_this.scenes[scene] || !_this.scenes[scene].hotspots) return [];
            var hotspots = [];
            _this.scenes[scene].hotspots.forEach(function(h) {
                if (h.type === "panorama") {
                    hotspots.push({
                        id: "h-".concat(h.id),
                        scene: h.scene,
                        pitch: h.pitch,
                        yaw: h.yaw
                    });
                }
            });
            return hotspots;
        };
        _this.loadCurrentScenes = function(playerScene, x) {
            var loadCurrent = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false;
            _this.showLoading(true);
            _this.pannellums[x].active = true;
            _this.props.onSceneChange(_this.scenes[playerScene]);
            var _playerScene = _this.scenes[playerScene], pitch = _playerScene.startPitch, yaw = _playerScene.startYaw, hfov = _playerScene.hfov;
            if (loadCurrent) {
                _this.pannellums[x].addScene(_this.scenes[playerScene]);
                _this.pannellums[x].loadScene({
                    scene: playerScene,
                    pitch: pitch,
                    yaw: yaw,
                    hfov: hfov
                });
                _this.pannellums[x].setNorthOffset(_this.scenes[playerScene].northYaw);
            } else {
                var animationTime = 1000;
                _this.pannellums[x].lookAt({
                    pitch: pitch,
                    yaw: yaw,
                    bounds: hfov,
                    time: animationTime
                });
            }
            _this.setState({
                current: x
            });
            // max 4 hotspots -> forward, backward, left, right
            var panoHotspots = _this.getPanoHotspots(playerScene);
            var currentScene = _this.scenes[_this.pannellums[x].getScene()];
            if (!currentScene) return;
            _this.props.markMinimap(currentScene);
            if (!_this.props.transition) return;
            // TODO: improve performence by not loading the same panorama twice
            panoHotspots.forEach(function(h, i) {
                var j = (x + i + 1) % 4; // find all the next pannellum instances
                var scene = _this.scenes[h.scene];
                if (!scene) return;
                _this.pannellums[j].active = false;
                _this.pannellums[x].hotspotsMap[h.id] = _this.pannellums[j];
                var p = scene.northPitch && currentScene.northPitch ? scene.northPitch - (currentScene.northPitch - h.pitch) : null;
                var y = scene.northYaw && currentScene.northYaw ? scene.northYaw - (currentScene.northYaw - h.yaw) : null;
                _this.pannellums[j].addScene(scene);
                _this.pannellums[j].loadScene({
                    scene: scene.name,
                    pitch: p,
                    yaw: y,
                    hfov: scene.hfov
                });
                _this.pannellums[j].setNorthOffset(scene.northYaw);
            });
        };
        _this.state = {
            loaded: false,
            current: 0
        };
        return _this;
    }
    var _proto = Panorama.prototype;
    _proto.componentDidUpdate = function componentDidUpdate(props) {
        var _this = this;
        return (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
            var _panoPose, hfov, pitch, yaw, _panoPose1, h, p, y;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        if (props.activePano !== _this.props.activePano) {
                            _this.props.panoramas.forEach(function(p) {
                                if (p.id === _this.props.activePano) _this.loadCurrentScenes(p.name, _this.state.current, true);
                            });
                        }
                        if (props.panoPose !== _this.props.panoPose) {
                            _panoPose = props.panoPose, hfov = _panoPose.hfov, pitch = _panoPose.pitch, yaw = _panoPose.yaw;
                            _panoPose1 = _this.props.panoPose, h = _panoPose1.h, p = _panoPose1.p, y = _panoPose1.y;
                            if (hfov !== h || pitch !== p || yaw !== y) {
                                _this.pannellums[_this.state.current].setPose(_this.props.panoPose);
                            }
                        }
                    case 2:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }))();
    };
    _proto.componentDidMount = function componentDidMount() {
        var _this = this;
        return (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
            var firstScene, options, _panoPose, pitch, yaw, hfov;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        ;
                        _this.props.panoramas.forEach(function(p) {
                            _this.scenes[p.name] = p;
                            if (p.default) firstScene = p;
                        });
                        // override default if activePano exists
                        _this.props.panoramas.forEach(function(p) {
                            if (_this.props.activePano && _this.props.activePano === p.id) firstScene = p;
                        });
                        options = {
                            loadCurrentScenes: _this.loadCurrentScenes,
                            updatePanoRotation: _this.props.updatePanoRotation,
                            openHotspot: _this.props.openHotspot,
                            onLoaded: _this.onPanoLoaded,
                            showLoading: _this.showLoading,
                            loadSelf: _this.loadSelf,
                            transition: _this.props.transition
                        };
                        _this.pannellums = [
                            new Pannellum((0,_object_spread/* default */.Z)({
                                id: 1,
                                autoLoad: false
                            }, options)), 
                        ];
                        if (!options.transition) {
                            // eslint-disable-next-line array-callback-return
                            Object.keys(_this.scenes).map(function(scene) {
                                _this.pannellums[0].addScene(_this.scenes[scene]);
                            });
                        } else {
                            _this.pannellums.push(new Pannellum((0,_object_spread/* default */.Z)({
                                id: 2
                            }, options)));
                            _this.pannellums.push(new Pannellum((0,_object_spread/* default */.Z)({
                                id: 3
                            }, options)));
                            _this.pannellums.push(new Pannellum((0,_object_spread/* default */.Z)({
                                id: 4
                            }, options)));
                        }
                        if (firstScene) {
                            _this.loadCurrentScenes(firstScene.name, 0, true);
                            _panoPose = _this.props.panoPose, pitch = _panoPose.pitch, yaw = _panoPose.yaw, hfov = _panoPose.hfov;
                            if (pitch || yaw || hfov) {
                                _this.pannellums[0].setPose(_this.props.panoPose);
                            }
                        }
                    case 7:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }))();
    };
    _proto.componentWillUnmount = function componentWillUnmount() {
        var _this = this;
        return (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
            var _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, pannellum;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                        _ctx.prev = 1;
                        // eslint-disable-next-line no-restricted-syntax
                        for(_iterator = _this.pannellums[Symbol.iterator](); !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                            pannellum = _step.value;
                            pannellum.destroyViewer();
                        }
                        _ctx.next = 9;
                        break;
                    case 5:
                        _ctx.prev = 5;
                        _ctx.t0 = _ctx["catch"](1);
                        _didIteratorError = true;
                        _iteratorError = _ctx.t0;
                    case 9:
                        _ctx.prev = 9;
                        _ctx.prev = 10;
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    case 12:
                        _ctx.prev = 12;
                        if (!_didIteratorError) {
                            _ctx.next = 15;
                            break;
                        }
                        throw _iteratorError;
                    case 15:
                        return _ctx.finish(12);
                    case 16:
                        return _ctx.finish(9);
                    case 17:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    1,
                    5,
                    9,
                    17
                ],
                [
                    10,
                    ,
                    12,
                    16
                ]
            ]);
        }))();
    };
    _proto.render = function render() {
        var _this = this;
        (0,renderDebug/* dLog */.a)("Panorama");
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            id: "panorama-overlay",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                    className: "btn close-btn",
                    onClick: function() {
                        return _this.props.handleTogglePano();
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                        className: "fas fa-times"
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    style: {
                        height: "100%",
                        width: "100%"
                    },
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            id: "panorama-player-1",
                            className: "panorama show"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            id: "panorama-player-2",
                            className: "panorama"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            id: "panorama-player-3",
                            className: "panorama"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            id: "panorama-player-4",
                            className: "panorama"
                        })
                    ]
                }),
                !this.state.loaded && /*#__PURE__*/ (0,jsx_runtime.jsx)(LoadingProgress/* default */.Z, {})
            ]
        });
    };
    return Panorama;
}(react.PureComponent);



/***/ })

}]);